import { frontendURL } from '../../helper/URLHelper';

export const LAIS_AGENT_PERMISSIONS = Object.freeze(['administrator', 'agent']);
export const LAIS_IMOVEIS_PERMISSIONS = Object.freeze([
  ...LAIS_AGENT_PERMISSIONS,
  'imoveis_manage',
]);
export const LAIS_VISITAS_PERMISSIONS = Object.freeze([
  ...LAIS_AGENT_PERMISSIONS,
  'visitas_manage',
  'chaves_manage',
]);
export const LAIS_CHAVES_PERMISSIONS = Object.freeze([
  ...LAIS_AGENT_PERMISSIONS,
  'chaves_manage',
]);
export const LAIS_LEADS_PERMISSIONS = Object.freeze([
  ...LAIS_AGENT_PERMISSIONS,
  'leads_manage',
]);
export const LAIS_CRM_SEND_PERMISSIONS = Object.freeze([
  ...LAIS_AGENT_PERMISSIONS,
  'leads_send_crm',
]);
export const LAIS_FINANCEIRO_PERMISSIONS = Object.freeze([
  ...LAIS_AGENT_PERMISSIONS,
  'financeiro_view',
]);
export const LAIS_POST_SALE_PERMISSIONS = Object.freeze([
  ...LAIS_AGENT_PERMISSIONS,
  'post_sale_view',
  'post_sale_manage',
  'post_sale_assign',
  'post_sale_status_change',
]);
export const LAIS_CAPTACAO_PERMISSIONS = Object.freeze([
  ...LAIS_AGENT_PERMISSIONS,
  'captador',
  'captacao_manage',
]);
export const LAIS_STORIES_PERMISSIONS = Object.freeze([
  ...LAIS_AGENT_PERMISSIONS,
  'vitrine_manage',
]);
export const LAIS_AGENCY_PERMISSIONS = Object.freeze([
  'administrator',
  'agent',
  'agency_manage',
]);
export const LAIS_REPORT_MANAGE_PERMISSIONS = Object.freeze([
  'administrator',
  'report_manage',
]);

export const laisPath = path =>
  frontendURL(`accounts/:accountId/${String(path).replace(/^\/+/, '')}`);

export const laisAliases = (...paths) => paths.flat().map(laisPath);

export const laisAgentMeta = (overrides = {}) => ({
  permissions: LAIS_AGENT_PERMISSIONS,
  ...overrides,
});

export const laisMeta = permissions => ({ permissions });

const resolveRedirectValue = (value, to) => {
  if (typeof value === 'function') return value(to) || {};
  return value || {};
};

export const laisCanonicalRoute = (to, name, options = {}) => ({
  name,
  params: {
    ...(to?.params || {}),
    ...resolveRedirectValue(options.params, to),
  },
  query: {
    ...(to?.query || {}),
    ...resolveRedirectValue(options.query, to),
  },
});

export const laisCanonicalRedirect =
  (name, options = {}) =>
  to =>
    laisCanonicalRoute(to, name, options);
